<template>
  <div class='h-dialogContainer h-alarm-filter'>
    <div class='row h-row-around-inputBox'>
      <div class='col-sm-6'>
        <div class='h-col-inputBox'>
          <div class='h-inputLit'>{{ $t('Alarm.eventLevel') }}:</div>
          <div class='row' id='eventLevelBox'>
            <div v-for='(event, index) in eventLevelList' :key='index' class='col-sm-3 nopadding'>
              <ejs-checkbox ref='eventLevelRef' :label='event.label' :value='event.value' :checked='event.checked'></ejs-checkbox>
            </div>
          </div>
        </div>
        <div class='h-col-inputBox'>
          <div class='h-inputLit'>{{ $t("Alarm.eventType") }}:</div>
          <div class='row' id='eventTypeBox'>
            <div v-for='(event, index) in eventTypeList' :key='index' class='col-sm-6 nopadding3'>
              <ejs-checkbox :label='event.label' :value='event.value' :checked='event.checked'></ejs-checkbox>
            </div>
          </div>
        </div>
      </div>
      <div class='col-sm-6'>
        <div class='h-col-inputBox'>
          <div class='h-inputLit'>{{ $t("Alarm.createTime") }}({{ $t('Alarm.notifystart') }}):</div>
          <ejs-datetimepicker v-model='startTime'  :locale='locale' :format='dateFormat' :step='60' timeFormat='HH:mm:ss'></ejs-datetimepicker>
        </div>
        <div class='h-col-inputBox'>
          <div class='h-inputLit'>{{ $t("Alarm.createTime") }}({{ $t('Alarm.notifyend') }}):</div>
          <ejs-datetimepicker v-model='endTime'  :locale='locale' :format='dateFormat' :step='60' timeFormat='HH:mm:ss'></ejs-datetimepicker>
        </div>
      </div>
    </div>
    <div class='row h-reset-margin'>
      <div class='h-outTabs h-dislogTabs'>
        <ejs-tab ref='filterTab' heightAdjustMode='Auto'>
          <!-- <e-tabitems> -->
            <!-- <e-tabitem :header='tab.name.header' content='#eventLogTopoTree'></e-tabitem>
            <e-tabitem :header='tab.type.header' content='#neTypeDom'></e-tabitem> -->
            <div class='e-tab-header'>
              <div>{{ this.$t('Alarm.nodeSelect') }} {{ this.$t('Alarm.byName') }}</div>
              <!--<div>{{ this.$t('Alarm.nodeSelect') }} {{ this.$t('Alarm.byType') }}</div>-->
            </div>
            <div class='e-content'>
              <div id='eventLogTopoTree'>
                <div class='h-padding-25'>
                  <div class='h-borderBox height-280'>
                    <!-- <TopoTree ref='filterTopoTree' :searchBox='{ show: true }' :checkBox='{ show: true }' :hasBorder='true'></TopoTree> -->
                    <TopoTree ref='filterTopoTree' :searchBox='{ show: true }' :checkBox='{ show: true }' :hasBorder='true' graphType="0"></TopoTree>

                  </div>
                </div>
                <div class='h-clear-bottomPadding'></div>
              </div>
              <!--
              <div id='neTypeDom'>
                <div class='h-padding-25'>
                  <div id='neTypeListDom' class='row height-280'>
                    <div v-for='(neType, index) in neTypeList' :key='index' class='col-sm-4 m-b-10'>
                      <ejs-checkbox :label='neType.label.toUpperCase()' :value='neType.value' :checked='neType.checked'></ejs-checkbox>
                    </div>
                  </div>
                </div>
              </div>
              -->
            </div>
          <!-- </e-tabitems> -->
        </ejs-tab>
        <!-- <div id='eventLogTopoTree' style='display: none'>
          <div class='h-padding-25'>
            <div class='h-borderBox height-280'>
              <TopoTree ref='filterTopoTree' :searchBox='{ show: true }' :checkBox='{ show: true }' :hasBorder='true'></TopoTree>
            </div>
          </div>
          <div class='h-clear-bottomPadding'></div>
        </div>
        <div id='neTypeDom' style='display: none;'>
          <div class='h-padding-25'>
            <div id='neTypeListDom' class='row height-280'>
              <div v-for='(neType, index) in neTypeList' :key='index' class='col-sm-4 m-b-10'>
                <ejs-checkbox :label='neType.label' :value='neType.value'></ejs-checkbox>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import TopoTree from '../../topoconfig/TopoTree';
import { EventBus } from '../../../plugins/eventBus';

export default {
  name: 'eventLogFilter',
  components: {
    TopoTree
  },
  data() {
    return {
      dateFormat: 'yyyy-MM-dd HH:mm:ss',
      eventLevelList: [
        { label: this.$t('Alarm.alarmLevel_0'), value: '0', checked: false },
        { label: this.$t('Alarm.alarmLevel_1'), value: '1', checked: false },
        { label: this.$t('Alarm.alarmLevel_2'), value: '2', checked: false },
        { label: this.$t('Alarm.alarmLevel_3'), value: '3', checked: false }
      ],
      eventTypeList: [
        { label: this.$t('Alarm.alarmType_0'), value: '0', checked: false },
        { label: this.$t('Alarm.alarmType_1'), value: '1', checked: false },
        { label: this.$t('Alarm.alarmType_2'), value: '2', checked: false },
        { label: this.$t('Alarm.alarmType_3'), value: '3', checked: false },
        { label: this.$t('Alarm.alarmType_4'), value: '4', checked: false }
      ],
      neTypeList: [],
      topoList: [],
      tab: {
        name: {
          header: { text: `${this.$t('Alarm.nodeSelect')}(${this.$t('Alarm.byName')})` }
        },
        // type: {
        //   header: { text: `${this.$t('Alarm.nodeSelect')}(${this.$t('Alarm.byType')})` }
        // }
      },
      locale: localStorage.getItem('locale'),
      startTime: '',
      endTime: '',
      conditions: {
        selectType: '0', // 0名称，1类型
        condition_neId: [],
        condition_neType: []
      }
    };
  },
  methods: {
    turnToFormateDate(dateValue) {
      dateValue = new Date(dateValue);
      let month = dateValue.getMonth() + 1;
      if (month < 10) {
        month = `0${month}`;
      }
      let day = dateValue.getDate();
      if (day < 10) {
        day = `0${day}`;
      }
      let hour = dateValue.getHours();
      if (hour < 10) {
        hour = `0${hour}`;
      }
      let minutes = dateValue.getMinutes();
      if (minutes < 10) {
        minutes = `0${minutes}`;
      }
      let sec = dateValue.getSeconds();
      if (sec < 10) {
        sec = `0${sec}`;
      }
      return `${dateValue.getFullYear()}-${month}-${day} ${hour}:${minutes}:${sec}`;
    },
    getArray(id) {
      const checkedDom = document.querySelectorAll(`#${id} [aria-checked=true] input`);
      const array = [];
      for (let i = 0; i < checkedDom.length; i++) {
        array.push(checkedDom[i].value);
      }
      return array;
    },
    setCondition(json) {
      if (json === undefined) {
        json = JSON.stringify({
          selectType: '0',
          condition_neId: [],
          condition_neType: []
        });
      }
      const conditions = JSON.parse(json);
      this.startTime = conditions.startTime ? this.turnToFormateDate(conditions.startTime) : '';
      this.endTime = conditions.endTime ? this.turnToFormateDate(conditions.endTime) : '';
      for (let i = 0; i < this.eventLevelList.length; i++) {
        this.eventLevelList[i].checked = false;
        if (conditions.condition_level) {
          for (let j = 0; j < conditions.condition_level.length; j++) {
            if (conditions.condition_level[j] === this.eventLevelList[i].value) {
              this.eventLevelList[i].checked = true;
            }
          }
        }
      }
      for (let i = 0; i < this.eventTypeList.length; i++) {
        this.eventTypeList[i].checked = false;
        if (conditions.condition_type) {
          for (let j = 0; j < conditions.condition_type.length; j++) {
            if (conditions.condition_type[j] === this.eventTypeList[i].value) {
              this.eventTypeList[i].checked = true;
            }
          }
        }
      }
      for (let i = 0; i < this.neTypeList.length; i++) {
        this.neTypeList[i].checked = false;
        if (conditions.condition_neType) {
          for (let j = 0; j < conditions.condition_neType.length; j++) {
            if (conditions.condition_neType[j] === this.neTypeList[i].value) {
              this.neTypeList[i].checked = true;
            }
          }
        }
      }
      this.$refs.filterTopoTree.uncheckAll();
      this.$refs.filterTopoTree.neIdListCache = {};
      for (let i = 0; i < this.topoList.length; i++) {
        this.$refs.filterTopoTree.neIdListCache[`${this.topoList[i]}`] = true;
      }
      this.$refs.filterTopoTree.change('');
      const tabObj = this.$refs.filterTab.ej2Instances;
      tabObj.select(parseInt(conditions.selectType, 10));
    },
    getCondition() {
      const returnData = JSON.parse(JSON.stringify(this.conditions));
      const levelData = this.getArray('eventLevelBox');
      if (levelData.length > 0) {
        returnData.condition_level = levelData;
      }
      const typeData = this.getArray('eventTypeBox');
      if (typeData.length > 0) {
        returnData.condition_type = typeData;
      }
      if (this.startTime) {
        if (!this.endTime) {
          EventBus.$emit('toast', {type: 'warning', content: this.$t('Alarm.pleaseSelectEndTime')});
          return false;
        }
        returnData.startTime = new Date(this.startTime).getTime();
      }
      if (this.endTime) {
        if (!this.startTime) {
          EventBus.$emit('toast', {type: 'warning', content: this.$t('Alarm.pleaseSelectStartTime')});
          return false;
        } else {
          const  startTime = new Date(this.startTime).getTime();
          const  endTime = new Date(this.endTime).getTime();
          if (endTime < startTime) {
            EventBus.$emit('toast', {type: 'warning', content: this.$t('Alarm.EndTimeLessThanStartTime')});
            return false;
          }
        }
        returnData.endTime = new Date(this.endTime).getTime();
      }
      if (this.$refs.filterTab.$el.querySelectorAll('.e-tab .e-toolbar-item')[0].className.indexOf('e-active') > -1) {
        returnData.selectType = '0';
      } else {
        returnData.selectType = '1';
      }
      this.topoList = [];
      const neIdList = [];
      const nodeList = this.$refs.filterTopoTree.getNodeList();
      for (let i = 0; i < nodeList.length; i++) {
        // if (nodeList[i].typeCode <= 10000) {
        neIdList.push(nodeList[i].id);
        this.topoList.push(nodeList[i].id);
        // }
      }
      returnData.condition_neId = neIdList;
      returnData.condition_neType = this.getArray('neTypeListDom');
      return JSON.stringify(returnData);
    },
    setTopoList(data) {
      this.topoList = data;
    },
    getTopoList() {
      return this.topoList;
    }
  },
  created() {
    this.$axios.get('/lte/ems/fm/event/filter').then((response) => {
      // this.eventTypeList = [];
      this.neTypeList = [];
      if (response && response.status === 200) {
        // for (let i = 0; i < response.data.alarmTypes.length; i++) {
        //   this.eventTypeList.push({
        //     label: response.data.alarmTypes[i].alarmTypeName,
        //     value: response.data.alarmTypes[i].alarmTypeIds,
        //     checked: false
        //   });
        // }
        for (let i = 0; i < response.data.neTypeList.length; i++) {
          this.neTypeList.push({
            label: response.data.neTypeList[i].netype,
            value: response.data.neTypeList[i].netypeid,
            checked: false
          });
        }
      }
    });
  }
};
</script>
